module.exports = __webpack_public_path__ + "static/media/trainers-next.e018cef2.png";